import Paper from "@material-ui/core/Paper";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { fetchJSON } from "helpers/axios";

const Acceptance = ({ authUser, settings }) => {
  const [acceptFor, setAcceptFor] = useState(null);

  useEffect(() => {
    const fetchAcceptance = async () => {
      try {
        const { token, ApplicantID } = authUser;
        const response = await fetchJSON(
          `api/AcceptanceForm?applicantId=${ApplicantID}`,
          null,
          "GET",
          token
        );
        setAcceptFor(response);
      } catch (error) {
        console.log(error);
      }
    };
    fetchAcceptance();
  }, [authUser]);

  return (
    <>
      <Paper
        elevation={3}
        style={{
          padding: "1.5rem",
          margin: "1rem auto",
          maxWidth: "800px",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
          minHeight: "auto",
          overflow: "auto" // Changed from "hidden" to "auto"
        }}
      >
        {acceptFor && (
          <div id="content" style={{ 
            fontSize: "12px", 
            lineHeight: "1.4",
            fontFamily: "Arial, sans-serif"
          }}>
            <div style={{ lineHeight: "1.5", color: "#333" }}>
              {/* Header Section - Compact */}
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginBottom: "1.5rem",
                paddingBottom: "1rem",
                borderBottom: "1px solid #e0e0e0"
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#2c3e50",
                    lineHeight: "1.3"
                  }}>
                    <div>The Provost</div>
                    <div>Ondo State College of Health Technology, Akure</div>
                    <div>Ondo State</div>
                  </div>
                </div>
                <div style={{
                  textAlign: "left",
                  fontSize: "11px",
                  color: "#555"
                }}>
                  <div style={{ marginBottom: "4px" }}>
                    <strong>Date:</strong>{" "}
                    {new Date().toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </div>
                  <div style={{ marginBottom: "4px" }}>
                    <strong>Admission No:</strong> {acceptFor?.Data?.ApplicantNumber}
                  </div>
                  <div>
                    <strong>Ref No:</strong> _______________
                  </div>
                </div>
              </div>

              {/* Title - Compact */}
              <div style={{
                textAlign: "center",
                marginBottom: "1.5rem",
                padding: "1rem",
                borderRadius: "6px",
                border: "1px solid #e9ecef",
              }}>
                <h2 style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#2c3e50",
                  textDecoration: "underline",
                  margin: "0",
                  letterSpacing: "0.3px"
                }}>
                  LETTER OF ACCEPTANCE OF ADMISSION INTO {acceptFor?.Data?.Session} ACADEMIC SESSION
                </h2>
              </div>

              {/* Content Sections - Compact */}
              <div style={{ fontSize: "11px", lineHeight: "1.5" }}>

                {/* Section 1 */}
                <div style={{ marginBottom: "0.8rem" }}>
                  <div style={{
                    padding: "1rem",
                    borderRadius: "6px",
                    border: "1px solid #ffeaa7",
                  }}>
                    <strong>1.</strong> I, <strong>
                      {acceptFor?.Data?.lastName} {acceptFor?.Data?.firstName} {acceptFor?.Data?.otherName}
                    </strong> of <strong>
                      {acceptFor?.Data?.StudentAddress}
                    </strong> with contact No. <strong>
                      {acceptFor?.Data?.StudentPhoneNo}
                    </strong> do hereby wish to abide by the following Terms and Conditions only as the means of being admitted into the Ondo State College of Health Technology, Akure having been prima-facie qualified and admitted to study, <strong>
                      {acceptFor?.Data?.department}
                    </strong> in the department of <strong>
                      {acceptFor?.Data?.department}
                    </strong>.
                  </div>
                </div>

                {/* Section 2 */}
                <div style={{ marginBottom: "0.8rem" }}>
                  <div style={{
                    padding: "1rem",
                    borderRadius: "6px",
                    border: "1px solid #bee5eb",
                  }}>
                    <div style={{ marginBottom: "0.8rem" }}>
                      <strong>2.</strong> I equally wish to state that I will abide by the Rules and Regulations of the College without exception and that:
                    </div>
                    <ul style={{
                      paddingLeft: "1.5rem",
                      margin: "0",
                      listStyleType: "disc"
                    }}>
                      <li style={{ marginBottom: "0.5rem" }}>
                        This admission is provisional and subject to passing probation examination or satisfying all other academic conditions/requirements to pursue the above-mentioned programme;
                      </li>
                      <li style={{ marginBottom: "0.5rem" }}>
                        All rules pertaining to occupants of hostels would be adhered to strictly by me;
                      </li>
                      <li style={{ marginBottom: "0.5rem" }}>
                        Payment of prescribed fees is non-refundable;
                      </li>
                      <li style={{ marginBottom: "0.5rem" }}>
                        The dress code vis-à-vis the professional ethics of each Department would be strictly adhered to;
                      </li>
                      <li style={{ marginBottom: "0" }}>
                        I will not let myself be directly or indirectly involved in cultism and other vices as long as I remain a student of the College.
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Section 3 */}
                <div style={{ marginBottom: "0.8rem" }}>
                  <div style={{
                    padding: "1rem",
                    borderRadius: "6px",
                    border: "1px solid #c3e6cb",
                  }}>
                    <div style={{ marginBottom: "0.8rem" }}>
                      <strong>3.</strong> The following documents are herewith attached:
                    </div>
                    <ul style={{
                      paddingLeft: "1.5rem",
                      margin: "0",
                      listStyleType: "disc"
                    }}>
                      <li style={{ marginBottom: "0.8rem" }}>
                        A letter of undertaking from my Parent/Sponsor and a Letter of Guarantor by a Christian Clergy or a Muslim Cleric, with their Mobile Number(s) guaranteeing my good behavior in compliance with the institution's Rules and Regulations.
                      </li>
                      <li style={{ marginBottom: "0" }}>
                        A Sworn Affidavit by the student giving information about his/her name, address, e-mail address, Mobile Number and e-mail address of parents in question, in a High Court of Justice required at the point of Registration, that I have voluntarily entered into these conditions without any pressure whatsoever.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Signature Section - Compact */}
              <div style={{
                marginTop: "2rem",
                padding: "1rem",
                borderRadius: "6px",
                border: "1px dashed #6c757d"
              }}>
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-end"
                }}>
                  <div style={{
                    textAlign: "center",
                    flex: 1,
                    marginRight: "1rem"
                  }}>
                    <div style={{
                      borderBottom: "1px solid #333",
                      width: "150px",
                      height: "40px",
                      margin: "0 auto 0.5rem auto"
                    }}></div>
                    <div style={{
                      fontSize: "10px",
                      fontWeight: "bold",
                      color: "#495057"
                    }}>
                      PARENT/GUARDIAN SIGNATURE
                    </div>
                  </div>

                  <div style={{
                    textAlign: "center",
                    flex: 1,
                    marginLeft: "1rem"
                  }}>
                    <div style={{
                      borderBottom: "1px solid #333",
                      width: "150px",
                      height: "40px",
                      margin: "0 auto 0.5rem auto"
                    }}></div>
                    <div style={{
                      fontSize: "10px",
                      fontWeight: "bold",
                      color: "#495057"
                    }}>
                      STUDENT SIGNATURE
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer Note - Compact */}
              <div style={{
                marginTop: "1.5rem",
                padding: "0.8rem",
                borderRadius: "4px",
                border: "1px solid #99d3ff",
                textAlign: "center",
                fontSize: "10px",
                color: "#0066cc",
              }}>
                <strong>Note:</strong> Please print this form, sign it with your parent/guardian, and submit it along with the required documents during registration.
              </div>
            </div>
          </div>
        )}
      </Paper>
    </>
  );
};

const mapStateToProps = ({ auth }) => {
  const authUser = auth.applicantUser;
  const settings = auth;
  return { authUser, settings };
};

export default connect(mapStateToProps, {})(Acceptance);